<template>
  <div class="lb">
    <div
      ref="barMian"
      class="barMian"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope95",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope95-【组件】双柱图竖轴",
      timer: null,
      defaultdata: [
        {
          value1: "数据一",
          value2: "系列一",
          value3: "450",
          // value4: "元",
        },
        {
          value1: "数据二",
          value2: "系列一",
          value3: "2200",
        },
        {
          value1: "数据三",
          value2: "系列一",
          value3: "400",
        },
        {
          value1: "数据四",
          value2: "系列一",
          value3: "300",
        },
        {
          value1: "数据五",
          value2: "系列一",
          value3: "100",
        },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "柱状图一图例", key: "value2" },
        { name: "柱状图一数据", key: "value3" },
        // { name: "单位", key: "value4" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.filter(
          (item) => item && item[this.valueMap[0].key]
        );
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.DrawEcharts();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let data1 = [];
      let legend = [];
      let vdata = JSON.parse(JSON.stringify(this.defaultdata));
      let xData = [...new Set(vdata.map((item) => item.value1))];
      vdata.map((item) => {
        if (item.value2 && (item.value3 || item.value3 == 0)) {
          data1.push(item.value3);
          // legend.push({
          //   show: true,
          //   top: "1%",
          //   right: "50%",
          //   itemHeight: 12, //图例的高度  文字左边那个
          //   itemWidth: 10,
          //   icon: "rect",
          //   textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
          //   data: [item.value2 || ""],
          // });
        }
      });
      const percent = (5 / xData.length) * 100;
      let zoom = [
        {
          id: "scope95", // 唯一的id
          yAxisIndex: [0], //滑动条为竖
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        // title: [
        //   {
        //     text: this.defaultdata[0].value4 || "",
        //     top: "0",
        //     left: "0",
        //     textStyle: {
        //       color: "#979AA0",
        //       fontSize: 12,
        //     },
        //   },
        // ],
        tooltip: {
          trigger: "axis",
        },
        // legend: [...legend],
        grid: {
          left: "5px",
          right: "20px",
          bottom: "10px",
          top: "10px",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
        },
        yAxis: {
          type: "category",
          z: 10,
          data: xData,
          axisLabel: {
            interval: 0,
            width: 80,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            overflow: "truncate", //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            data: data1,
            type: "bar",
            name: vdata[0].value1 || "",
            showBackground: true,
            backgroundStyle: {
              // width: "120%", // 设置背景宽度，可以是具体像素值，也可以是百分比
              // height: "100%", // 设置背景高度，可以是具体像素值，也可以是百分比
              // borderRadius: 4,
              backgroundColor: "rgba(200, 200, 200, 0.3)",
            },
            showBackground: true,
            name: vdata[0].value2 || "",
            barWidth: 15,
            barGap: "40%",
            label: {
              normal: {
                show: true,
                position: "right",
                color: "#60ebd0",
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                1,
                [
                  {
                    offset: 0,
                    color: "#1d4d51", // 0% 处的颜色
                  },

                  {
                    offset: 1,
                    color: "#60ebd0", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
          },
        ],
        dataZoom: xData.length > 5 ? zoom : [],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function () {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData(); //需要刷新的数据
    this.DrawEcharts();
  },
};
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
